// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://api.gloriglobalmakmur.com/api/v1',
  SITE_URL: 'https://gloriglobalmakmur.com',
  // TODO: fill with the GA4 Measurement ID (G-XXXXXXXXXX) for gloriglobalmakmur.com
  GA_MEASUREMENT_ID: '',
};
